import React, { useEffect, useState } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//datefomatter
import { format } from 'date-fns';
//styles
import styles from 'src/asset/scss/style/calc.module.scss';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//hook
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//comp-wrapper
import Section from 'src/webapp/views/wrapper/Section';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import Menu from 'src/webapp/views/component/Menu';//메뉴
import TitleBar from 'src/webapp/views/component/title/TitleBar';
import EmptyData from 'src/webapp/views/component/EmptyData';//데이터없음
import Calc from './Calc';//정산내역
import DateRangeBottomsheet from 'src/webapp/views/component/datepicker/DateRangePicker';//공통 - date-range bottomsheet

export default function CalcList() {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { isState, partner } = usePartnerStore();
    const { excelExportAPI } = useComnHook();//엑셀익스포트

    /* =============== 조회날짜-bottomsheet로 전달 =============== */
    const today = new Date();//오늘날짜
    const [ startDate,setStartDate ] = useState(new Date(today.setDate(today.getDate() - 7)));
    const [ endDate,setEndDate ] = useState(new Date());
    /* =============== 조회날짜-bottomsheet로 전달 =============== */
    /* =============== 날짜선택 팝업오픈여부 =============== */
    const [ datepicker,setDatePicker ] = useState(false);
    const onDatePickerDismissHandler = (value) => {
        setDatePicker(value);
    }
    /* =============== 날짜선택 팝업오픈여부 =============== */
    /* =============== 정산리스트 =============== */
    const [ calcList, setCalcList ] = useState([]);
    const calcListAPI = async() => {
        const DATA = { PARTNER_CD:partner.COMN_CD, START_DATE:format(startDate, 'yyyyMMdd'), END_DATE:format(endDate, 'yyyyMMdd') };
        const result = await axiosPostHandler(`partnerCalcListForPartner.do`, DATA);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            setCalcList(result.data);
        }
    };
    useEffect(() => {
        if(!isState) { return; }
        
        calcListAPI();
    }, [isState, startDate, endDate]);
    /* =============== 정산리스트 =============== */
    /* =============== 매출리스트 엑셀다운로드 =============== */
    const excelExportHandler = async() => {
        const DATA = { PARTNER_CD:partner.COMN_CD, START_DATE:format(startDate, 'yyyyMMdd'), END_DATE:format(endDate, 'yyyyMMdd') };
        const url = `${process.env.REACT_APP_BACK_HOST}partnerCalcListExcel.do`;
        const filename = `[두바키 파트너스]${format(startDate, 'yyyy.MM.dd')} - ${format(endDate, 'yyyy.MM.dd')}정산 관리`;

        excelExportAPI(DATA, url, filename);//엑셀다운로드API
    };
    /* =============== 매출리스트 엑셀다운로드 =============== */
    /* =============== 총 정산액 합산 =============== */
    const totPrice = calcList.reduce(function add(sum, currValue) {
        return sum + parseInt(currValue.CALC_PRICE.replaceAll(',', ''));
    }, 0);
    /* =============== 총 정산액 합산 =============== */

    return (
        <>
        <Section className={"section sectionContainer"}>
            <Menu />
            <Element tag={`div`} className={`container`}>
                <FixedPanel>
                    <TitleBar title={`정산 관리`} />
                    <Element tag={`div`} className={styles.headContainer}>
                        <Element tag={`div`} className={styles.searchContainer}>
                            <Element tag={`time`}>{format(startDate, 'yyyy.MM.dd') + ' - ' + format(endDate, 'yyyy.MM.dd')}</Element>
                            <Element tag={`div`} className={styles.btnArea}>
                                <Element tag={`button`} anyprop={(e) => onDatePickerDismissHandler(true)}><FontAwesomeIcon icon="fa-light fa-calendar-lines" /></Element>
                                <Element tag={`button`} anyprop={(e) => excelExportHandler()}><FontAwesomeIcon icon="fa-light fa-arrow-down-to-line" /></Element>
                            </Element>
                        </Element>
                        <Element tag={`div`} className={styles.valueContainer}>
                            <dl><dt><p>총 정산액</p></dt><dd><label>{totPrice.toLocaleString('ko-KR')}원</label></dd></dl>
                        </Element>
                    </Element>
                </FixedPanel>
                <FlickPanel>
                    {calcList.length > 0 ?
                        <Element tag={`ul`} className={styles.calcContainer}>
                            {calcList.map((item, idx) =>
                                <Element tag={`li`} key={idx}>
                                    <Calc data={item} />
                                </Element>
                            )}
                        </Element>
                    : <Element tag={`div`} className={styles.emptyData}><EmptyData content={`정산내역은`} /></Element>}
                </FlickPanel>
            </Element>            
        </Section>

        {/* date-range - bottomsheet */}
        {datepicker ? <DateRangeBottomsheet isOpen={datepicker} onDismiss={onDatePickerDismissHandler} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} minDate={null} maxDate={new Date()} /> : null}
        </>
    );
}